const VideoTagView = Backbone.View.extend({
  collection: new Backbone.Collection([], {
    model: Backbone.Model.extend({
      defaults: {
        'errorMessage': '',
        'videoLotID': 0,
        'saleNumber': '',
        'lotNumber': '',
        'tagID': 0,
        'lotExtension': '',
        'videoID': 0
      }
    })
  }),
  initialize(opt) {
    this.options = opt;
    this.listenTo(phillips.Events, 'addTag', this.addTag);
    this.listenTo(phillips.Events, 'showTags', this.render);
    this.listenTo(phillips.Events, 'close', this.close);
    if ($('.editTagBoxTemp').html() !== '') {
      this.template = _.template($('.editTagBadgeTemp').html());
    }
    this.badgeDesc = opt.badgeDesc || '';
  },
  events: {
    'click .badge': 'showContacts',
    'click .delete-tag': 'deleteTag'
  },
  render(collection) {
    const that = this;
    if (collection) {
      this.collection = collection;
    }
    if (this.collection) {
      if (this.key === 'departmentLocations') {
        _.forEach(this.collection.models, function(item, key) {
          var locationModel = item.get(that.options.badgeDesc);
          this.$el.append(this.template({
            badgeDesc: locationModel.get('locationName'),
            modelId: 'location' + locationModel.get('locationID'),
            'tagID': item.get('departmentLocationID'),
            'propName': 'departmentLocationID'
          }));
        }, this);
      } else {
        this.collection.models.forEach((item) => {
          this.$el.append(this.template({
            badgeDesc: item.get(this.badgeDesc),
            'tagID': item.get('tagID'),
            'propName': 'tagID'
          }));
        });
      }
    }
  },
  addTag(model) {
    // adds passed in model from 'addTag' trigger event
    this.collection.add(model);
    this.$el.empty();
    this.render();
  },
  showContacts: function(e) {
    var locationModel = this.collection.findWhere({ 'locationID': $(e.currentTarget).data('id') });
  },
  deleteTag: function(e) {
    var tagID = $(e.currentTarget).data('tag-id');
    var propName = $(e.currentTarget).data('prop-name');
    var deleteModel = this.collection.find(function(model) {
      if (model.get(propName) === tagID) {
        return model;
      }
    }, this);
    this.collection.remove(deleteModel);
    this.$el.empty();
    this.render();
  },
  close() {
    this.$el.empty().remove();
    this.stopListening();
  }
});

export default VideoTagView;
